import CardTemplate from "components/card/card-template/CardTemplate";
import { HoursOperation } from "components/hours-operation/HoursOperation";
import { MemberService } from "components/member-service/MemberService";
import React from "react";

interface UnableToFinishProps {
    referenceNumber: string;
}

const UnableToFinish = ({ referenceNumber }: UnableToFinishProps) => {
    // ========== Render ==========
    return (
        <CardTemplate title="Unable to Finish - Please Call to Apply" className="text-base-content">
            <div className="font-medium text-base-content text-base flex flex-col gap-5">
                <p className="leading-6 text-base text-base-content font-medium font-sans" id="unable-to-finish">
                    Unfortunately, we were unable to verify the information you submitted to the online form.
                </p>

                <p className="leading-5 text-sm text-base-content font-medium pr-4">
                    Your application is not complete and you do not have life insurance coverage. Here is a reference number
                    regarding your case: {referenceNumber}.
                </p>

                <p className="leading-5 text-sm text-base-content font-medium pr-4">
                    Please contact AAA Life to apply by phone.
                </p>

                <MemberService email={false} titleClassName="text-black/90" />

                <HoursOperation
                    className="text-black/90"
                    firstLine="Monday - Friday 8 am - 8 pm EST"
                    secondLine="Saturday 11 am - 3 pm EST"
                />
            </div>
        </CardTemplate>
    );
};

export default UnableToFinish;
